export default __webpack_public_path__ + "static/media/Fireworks.dea62644.gif";